import { registerTab } from "lib/@components/tabs"
import { PeriodSummaries } from "routes/asset-register/plugins/regime-display/plugins/task-summaries/plugins/asset-task-perspective/period/period-summaries"

registerTab({
    tab: "assetTaskPerspective",
    id: "period",
    title: "Periods",
    content: <PeriodSummaries $lazy />,
})
